import React, { memo } from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import { DRIVER_IN_OUT_FORM_STATE } from 'apps/fleet-planner/hooks/useDriverInOutForm'
import { ITimeFormats } from 'apps/fleet-planner/utils/userDateTimeSettings'
import { CheckInIcon, EditIcon } from 'transfix-icons'
import { DISPLAY } from 'constants/display'
import { formatDateTime } from './utils'

interface ICheckInTimesProps {
  isEditable?: boolean
  checkedInAt?: string | null
  displayTimezone?: string
  stopType: string
  sequence: number
  timeFormats: ITimeFormats
  onButtonClick?: (state: DRIVER_IN_OUT_FORM_STATE) => void
}

export const CheckInTimes = memo<ICheckInTimesProps>(
  ({
    checkedInAt,
    displayTimezone,
    isEditable = false,
    onButtonClick,
    sequence,
    stopType,
    timeFormats,
  }) => {
    const openCheckInHandler = () => {
      if (onButtonClick) onButtonClick(DRIVER_IN_OUT_FORM_STATE.checkedInAt)
    }
    return (
      <div className='flex items-center'>
        <CheckInIcon size='large' color={checkedInAt ? 'info' : 'coolGray5'} />
        {checkedInAt ? (
          <p
            data-test={`checked-in-${stopType}-${sequence}`}
            className='pl2 pr2 text-success body-semibold'>
            {formatDateTime(timeFormats, checkedInAt, undefined, displayTimezone || undefined)}
          </p>
        ) : (
          <p
            data-test={`checked-in-empty-${stopType}-${sequence}`}
            className='pl2 pr2 text-secondary'>
            {DISPLAY.emptyDateTime}
          </p>
        )}
        {onButtonClick && isEditable && (
          <IconButton
            className='clear-filter'
            Icon={EditIcon}
            onClick={openCheckInHandler}
            label='In Out Times'
            size='large'
          />
        )}
      </div>
    )
  }
)
